import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './restrictioninfo.styl'


export default class RestrictionInfo extends Component {
  static propTypes = {
    restriction: PropTypes.string
  }

  static defaultProps = {
    restriction: ''
  }

  render () {
    const { restriction } = this.props

    return (
      <div className={`${styles.restrictionInfo}`}>
          <span>{restriction}</span>
      </div>
    )
  }
}
